import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Option, ViewSelector } from '../../../../../infra/ui/view-selector';
import styles from './styles.module.scss';
var filters = [
    {
        key: 'all',
        label: (_jsxs("div", { children: ["All", _jsx("div", { className: styles['desktop-rendered'], children: " campaigns" })] })),
    },
    { key: 'scheduled', label: _jsx("div", { children: "Scheduled" }) },
    { key: 'draft', label: _jsx("div", { children: "Drafts" }) },
    { key: 'completed', label: _jsx("div", { children: "Sent" }) },
];
export var StatusFilter = function (_a) {
    var status = _a.status, onStatusChange = _a.onStatusChange;
    return (_jsx("div", { className: styles['status-filter-container'], "data-automation-id": "container:filter", children: _jsx(ViewSelector, { children: filters.map(function (filter) { return (_jsx(Option.Button, { id: "engage-list-status-filter-".concat(filter.key), className: styles['status-filter-option'], isActive: status === filter.key, onClick: function () { return onStatusChange(filter.key); }, children: filter.label }, filter.key)); }) }) }));
};
